<template>
  <div class="c-journal-sign">
    <div v-if="sign && !!qrData &&author">
      <template v-if="!onlyQr">
        {{ author.position }}, {{ author.fullName }}
      </template>
      <div v-if="!!qrData" class="qr">
        <a :href="sign.checkUrl" target="_blank">
          <img width="82" height="82" :src="qrData" alt="sign" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { createQR, } from 'components/Document/utils'

export default {
  name: 'CJournalSign',
  props: {
    sign: { type: Object, default: () => ({}), },
    onlyQr: { type: Boolean, default: false, },
  },
  computed: {
    author() {
      return this.sign?.author
    },
    qrData() {
      if (!this.sign) {
        return ''
      }
      return (this.sign?.isApproved !== null) ? createQR(this.sign?.checkUrl, 4, 'L') : ''
    },
  },
}
</script>

<style lang="scss" scoped>
.c-journal-sign {

  .qr {
    display: flex;
    a { display: inherit; }
  }
}
</style>
